import {plugin_registry, PluginBase} from "nk-plugin-registry";
import '../scss/events.scss';

@plugin_registry.register('EventCalendar')
class EventCalendar extends PluginBase {

}
